<h3>{{ settings.lang.DuplicateFamiliesComponent }}</h3>
<data-area [settings]="area"></data-area>
<button mat-raised-button color="primary" (click)="ngOnInit()">
  {{ settings.lang.search }}
</button>
<table
  class="table table-bordered"
  *ngIf="duplicateFamilies && duplicateFamilies.length > 0"
>
  <tr>
    <th></th>
    <th *ngIf="name">{{ settings.lang.familyName }}</th>
    <th *ngIf="tz">{{ settings.lang.socialSecurityNumber }}</th>
    <th *ngIf="address" (click)="sortByAddress()">
      {{ settings.lang.address }}
    </th>
    <th *ngIf="phone">{{ settings.lang.phone }}</th>
    <th (click)="sortByCount()">{{ settings.lang.families }}</th>
    <th>{{ settings.lang.total }} {{ duplicateFamilies.length }}</th>
  </tr>
  <tr
    *ngFor="let d of duplicateFamilies; let i = index"
    [class.deliveredOk]="viewdFamilies.get(d.ids)"
  >
    <td>{{ i + 1 }}</td>
    <td *ngIf="name">{{ d.name }}</td>
    <td *ngIf="tz">{{ d.tz }}</td>
    <td *ngIf="address">{{ d.address }}</td>
    <td *ngIf="phone">{{ d.phone }}</td>
    <td>{{ d.count }}</td>
    <td>
      <a (click)="showFamilies(d)">{{ settings.lang.showFamilies }}</a>
    </td>
  </tr>
</table>
